/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private _emitChangeSource = new Subject<any>();
  changeEmitted$ = this._emitChangeSource.asObservable();
  emitChange(change: any): void {
    this._emitChangeSource.next(change);
  }

  //Customizer

  private _emitCustomizerSource = new Subject<any>();
  customizerChangeEmitted$ = this._emitCustomizerSource.asObservable();
  emitCustomizerChange(change: any): void {
    this._emitCustomizerSource.next(change);
  }

  //customizer - compact menu

  private _emitCustomizerCMSource = new Subject<any>();
  customizerCMChangeEmitted$ = this._emitCustomizerCMSource.asObservable();
  emitCustomizerCMChange(change: any): void {
    this._emitCustomizerCMSource.next(change);
  }

  //customizer - compact menu

  private _emitNotiSidebarSource = new Subject<any>();
  notiSidebarChangeEmitted$ = this._emitNotiSidebarSource.asObservable();
  emitNotiSidebarChange(change: any): void {
    this._emitNotiSidebarSource.next(change);
  }
}
